import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { rem } from "@/plugins/rem";
import { isMobile } from "./tools/device";
import { ref, provide, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isMove = ref(isMobile());

provide("isMove", isMove.value);
onMounted(() => {
  if (isMove.value) {
    rem();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})